import React, { useState } from 'react'
import { useTranslation } from 'lib/i18n'
import trackProfileSubscribed from 'lib/tracking/avo/trackProfileSubscribed'

import EmailSignupForm from 'components/EmailSignupForm/EmailSignupForm'
import useCustomerData from 'hooks/useCustomerData'
import useSubscribeToChanges from 'hooks/useSubscribeToChanges'

const SubscribeToChangesForm = ({ profile, darkTextColor = false }) => {
  const { t } = useTranslation()
  const [done, setDone] = useState(false)
  const customerData = useCustomerData()

  const [subscribe, { loading }] = useSubscribeToChanges({
    onCompleted: () => {
      setDone(true)
    },
  })

  const formText = profile?.acceptingOrders
    ? t(
        'ProfileSignup.infoTextAcceptingOrders',
        'Be the first to know when {{profileName}} adds more products. Sign up and we will get back to you!',
        {
          profileName: profile?.name,
        },
      )
    : t(
        'ProfileSignup.infoTextNotAcceptingOrders',
        'Be the first to know when {{profileName}} goes live. Sign up and we will get back to you!',
        {
          profileName: profile?.name,
        },
      )

  return (
    <div data-cy="subscribeToChanges">
      <EmailSignupForm
        subscribe={subscribe}
        loading={loading}
        done={done}
        onFinish={(input) => {
          if (customerData) {
            customerData.logEvent('profile-subscribe', {
              email: input.email,
              profileId: profile.id,
            })
            customerData.modify({ email: input.email })
          }
          trackProfileSubscribed({
            profile,
          })
          subscribe({ ...input, profileId: profile.id })
        }}
        text={formText}
        darkTextColor={darkTextColor}
      />
    </div>
  )
}

export default SubscribeToChangesForm
